//import { styled } from '@mui/material/styles';

import * as React from "react";
import { useState, useEffect, useContext } from "react";
import {
  BrowserRouter as Router,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  DataGrid,
  GridColumns,
  GridRowId,
  GridRowsProp,
  GridRowParams,
  GridValueGetterParams,
  GridValueSetterParams,
  GridCellValue,
} from "@mui/x-data-grid";

import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import { confirmAlert } from "react-confirm-alert";
import Grid from "@mui/material/Grid";

/* ICONES */
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ApprovalIcon from "@mui/icons-material/Approval";
import SaveIcon from "@mui/icons-material/Save";
import AssessmentIcon from "@mui/icons-material/Assessment";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import IconButton from "@mui/material/IconButton";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import Download from "@mui/icons-material/Download";
import WarningIcon from "@mui/icons-material/Warning";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";

/* Dialog */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

/* Datapicker */
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

/* DADOS */
import ForecastDiarizadoDataSet from "../../components/data/ForecastDiarizadoDataSet";
//import ForecastDataSetPortal from "../../components/data/ForecastDataSetPortal";

/* CLASSES */
import ForecastDiarizado from "../../components/classes/ForecastDiarizado";
import Contrato from "../../components/classes/Contrato";
import UnidadeArmazenamento from "../../components/classes/UnidadeArmazenamento";
import UnidadeArmazenamentoDataset from "../../components/data/UnidadeArmazenamentoDataSet";

/* COMPONENTES CUSTOMIZADOS */
import ForecastTopo from "./topo";
import ForecastDiarizadoPassoAPasso from "./forecastDiarioPassos";
import FileUpload from "../../components/common/FileUpload";
import PageHelper from "../../helper/pageHelper";
import StepLogsHistoryDetalhe from "../../components/common/StepLogsHistoryModal/StepLogsHistoryDetalhe";

/* D O W N L O A D */
import { CSVLink, CSVDownload } from "react-csv";

/* LOCALIZAÇÃO */

import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Send } from "@mui/icons-material";
import { Alert, Modal, Snackbar } from "@mui/material";
import ForecastDiarioModal from "./forecastDiarioModal";
import SkuDescricao from "../../components/common/SkuDescricao";
import ForecastDiarioMoverPlanoModal from "./forecastDiarioModalMoverPlano/forecastDiarioMoverPlanoModal";
import { UserContext } from "../../App";
import moment from "moment";
import DownloadCSVModal from "../../components/common/DownloadCSVModal/DownloadCSVModal";
import Utils from "../../helper/utils";
import CSVDetalhesModal from "../../components/common/CSVDetalhesModal/CSVDetalhesModal";

import styles from "./detail.module.css";
import AutocompleteSKU from "../../components/common/AutocompleteSku";

import { useTranslation } from "react-i18next";

enum FILTER_NAMES {
  valueDTinicio = "dataInicio",
  valueDTfim = "dataFim",
  codigoSku = "skus",
  descricaoSku = "descricaoSku",
  centroDistribuicao = "centro",
  mesAnoReferencia = "mesAnoReferencia",
  quantidade = "quantidade",
}

interface IFilter {
  [FILTER_NAMES.valueDTinicio]?: Date | null;
  [FILTER_NAMES.valueDTfim]?: Date | null;
  [FILTER_NAMES.mesAnoReferencia]?: Date | null;
  [FILTER_NAMES.codigoSku]?: string[];
  [FILTER_NAMES.descricaoSku]?: string;
  [FILTER_NAMES.centroDistribuicao]?: string;
  [FILTER_NAMES.quantidade]?: string;
}

/* G R I D */
interface Data {
  id: number;
  codigoFornecedorSap: number;
  numeroContrato: string;
  idSku: string;
  descricao: string;
  centro: string;
  anoMesRef: string;
  dia: String;
  quantidade: number;
  quantidadeProposta: number;
  justificativa: string;
  quantidadeMensal: number;
  projeto: string;
  siglaSku: string;
}

interface download {
  idSku: string;
  centro: string;
  dia: string;
  quantidade: string;
  justificativa: string;
}

export default function ForeCastDiarioPage() {
  const { t } = useTranslation();

  const user: any = useContext(UserContext);

  let query = useQuery();
  let _step: number =
    query.get("step")?.valueOf() === undefined
      ? 1
      : Number(query.get("step")?.valueOf());

  const codigoFornecedorSap: number = Number(
    localStorage.getItem("CodigoFornecedorSAPSelecionado")
  );
  const contrato: Contrato = JSON.parse(
    String(localStorage.getItem("ContratoSelecionado"))
  );
  const step = _step > 0 && _step < 5 ? _step : 4;

  const [habilita, setHabilita] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [historyId, setHistoryId] = useState(0);

  /* MODAL */
  const [openModal, setOpenModal] = React.useState<boolean>(false);
  const [openModalMoverPlano, setOpenModalMoverPlano] = React.useState<{
    isOpen: boolean;
    idForecastAtual: number;
  }>({ isOpen: false, idForecastAtual: -1 });
  const [openDownloadCSVModal, setOpenDownloadCSVModal] =
    useState<boolean>(false);
  const [openCSVDetalhesModal, setOpenCSVDetalhesModal] =
    useState<boolean>(false);
  const [openSnackBar, setOpenSnackBar] = React.useState<boolean>(false);
  const [openPlanoMovidoSnackBar, setOpenPlanoMovidoSnackBar] =
    React.useState<boolean>(false);
  const [csvFoiEnviado, setCsvFoiEnviado] = useState<{
    wasUpdated: boolean;
    isSuccess: boolean;
    details: string;
  }>({ wasUpdated: false, isSuccess: false, details: "" });
  const [planoFoiMovido, setPlanoFoiMovido] = useState<{
    wasUpdated: boolean;
    isSuccess: boolean;
  }>({ wasUpdated: false, isSuccess: false });

  /* PAGINAÇÃO */

  const [pageSize, setPageSize] = useState(50);
  const [forecasts, setForecasts] = React.useState<ForecastDiarizado[]>([]);
  const [forecastsTemp, setForecastsTemp] = useState<ForecastDiarizado[]>([]);

  const dataForecastDiarizado: ForecastDiarizadoDataSet =
    new ForecastDiarizadoDataSet();
  const dataSKU: UnidadeArmazenamentoDataset =
    new UnidadeArmazenamentoDataset();

  /* FILTER */
  const [filter, setFilter] = useState({} as IFilter);

  const handleChangeFilter = React.useCallback((event) => {
    setFilter((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  }, []);

  const [valorAnterior, SetValorAnterior] = React.useState(0);
  const [filtra, setFiltra] = React.useState(false);

  const [rows, setRows] = React.useState<Data[]>([]);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  const titleAprova: string = t("pages.dailyForecast.text.approvesAllItems");

  useEffect(() => {
    const fetchData = async () => {
      Utils.setDocumentTitle(
        contrato
          ? contrato.numeroContrato.valueOf()
          : t("pages.dailyForecast.text.withoutContract"),
        `| Step ${step} - ${t("pages.dailyForecast.titlePage")}`
      );
      if (codigoFornecedorSap && contrato?.numeroContrato && step) {
        const data = await dataForecastDiarizado.ListarAtivosPorPasso(
          codigoFornecedorSap,
          String(contrato.numeroContrato),
          step
        );
        setForecastsTemp(data);
        setForecasts(data);
        preencherGrid(data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    };
    fetchData().catch(console.error);
  }, []);

  useEffect(() => {
    setOpen(false);
    if (csvFoiEnviado.wasUpdated) {
      console.log(csvFoiEnviado.details);
      setOpenSnackBar(true);
      if (csvFoiEnviado.isSuccess) {
        setLoading(true);
        dataForecastDiarizado
          .ListarAtivosPorPasso(
            codigoFornecedorSap,
            String(contrato.numeroContrato),
            step
          )
          .then((data) => {
            if (data) {
              setForecasts(data);
              preencherGrid(data);
            }
            setLoading(false);
          });
      }
    }
  }, [csvFoiEnviado]);

  useEffect(() => {
    if (planoFoiMovido.wasUpdated) {
      setOpenPlanoMovidoSnackBar(true);
      if (planoFoiMovido.isSuccess) {
        setLoading(true);
        dataForecastDiarizado
          .ListarAtivosPorPasso(
            codigoFornecedorSap,
            String(contrato.numeroContrato),
            step
          )
          .then((data) => {
            if (data) {
              preencherGrid(data);
            }
            setLoading(false);
          });
      }
    }
  }, [planoFoiMovido]);

  const handleClickSave = () => {
    forecasts.forEach((forecast: ForecastDiarizado) => {
      forecast.step = step;
    });
    dataForecastDiarizado.AtualizarColecao(forecasts).then((result) => {
      if (result) {
        Mensagem(
          t("common.warning"),
          t("pages.dailyForecast.text.gridItemsUpdatedSuccessfully")
        );
      } else {
        Mensagem(
          t("common.error"),
          t("pages.dailyForecast.text.gridItemsProblems")
        );
      }
    });
  };

  function handleClickDadosForecast() {
    setOpenModal(true);
  }

  const handleClickAprove = () => {
    forecasts.forEach((forecast) => {
      switch (step) {
        case 1:
          forecast.quantidadeProposta = 0;
          forecast.aprovadoBRF = false;
          forecast.aprovadoParceiro = true;
          break;
        case 4:
        case 2:
          forecast.aprovadoBRF = true;
          forecast.aprovadoParceiro = true;
          break;
        default:
          forecast.aprovadoBRF = false;
          forecast.aprovadoParceiro = true;
          break;
      }
    });

    atualizarForecasts(true, forecasts);
  };

  function atualizarForecasts(
    approve: boolean,
    forecastsList: ForecastDiarizado[]
  ) {
    setLoading(true);
    var complemento: string =
      step === 50 ? t("pages.dailyForecast.text.rememberOperationWithSap") : "";
    dataForecastDiarizado
      .AtualizarColecao(forecastsList)
      .then((result) => {
        atualizaListaForecast().then(() => {
          setLoading(false);
          if (result) {
            if (approve) {
              Mensagem(
                t("common.warning"),
                t("pages.dailyForecast.text.allItemsWereApproved") +
                  complemento,
                true
              );
            } else {
              Mensagem(
                t("common.warning"),
                t("pages.dailyForecast.text.allItemsWereNotApproved"),
                true
              );
            }
          } else {
            Mensagem(
              t("common.error"),
              t("pages.dailyForecast.text.itemsWereNotProcessed"),
              true
            );
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Mensagem(
          t("common.error"),
          t("pages.dailyForecast.text.itemsWereNotProcessed"),
          true
        );
      });
  }

  async function atualizaListaForecast() {
    const data = await dataForecastDiarizado.ListarAtivosPorPasso(
      codigoFornecedorSap,
      String(contrato.numeroContrato),
      step
    );
    setForecasts(data);
    preencherGrid(data);
  }

  const handleClickNotAprove = () => {
    forecasts.forEach((forecast) => {
      forecast.aprovadoBRF = false;
      forecast.aprovadoParceiro = false;
    });
    atualizarForecasts(false, forecasts);
  };

  const columns: GridColumns = MontaColunas(step);

  const handleConfimation = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.yes"),
          onClick: async () => {
            await setOpen(false);
            handleClickAprove();
          },
        },
        {
          label: t("common.no"),
          onClick: () => {
            setOpen(false);
          },
        },
      ],
    });
  };

  const handleClick = (cellValues: any) => {
    const forecast: ForecastDiarizado | undefined = forecasts.find(
      (f) => f.id === Number(cellValues.row.id)
    );

    if (cellValues.field === "saveico" && !user.isSuporte) {
      if (forecast) {
        dataForecastDiarizado.Atualizar(forecast).then((result) => {
          if (result) {
            Mensagem(
              t("common.warning"),
              `${t("pages.dailyForecast.text.itemUpdatedSuccessfully")}\n\r`,
              false,
              0,
              true
            );
          } else {
            Mensagem(
              t("common.error"),
              `${t("pages.dailyForecast.text.errorSavingItem")}\n\r`,
              false,
              0,
              true
            );
          }
        });
      }
    }
  };

  const maxQtyPerMonth = React.useMemo(() => {
    if (!rows) return null;
    const maxQuantityFullMonth = rows.reduce((acc, act) => {
      const monthYear = act.dia.substring(3);
      if (!acc[monthYear])
        acc[monthYear] = { monthly: act.quantidadeMensal || 0, used: 0 };
      acc[monthYear] = {
        ...acc[monthYear],
        used: acc[monthYear].used + act.quantidade,
      };
      return acc;
    }, {} as { [key: string]: { monthly: number; used: number } });
    return maxQuantityFullMonth;
  }, [rows]);

  function MontaColunas(_step: number): GridColumns {
    let cols: GridColumns = [];

    if (forecasts.length == 0) {
      return cols;
    }

    if (step <= 1) {
      cols = [
        {
          field: "id",
          headerName: "#",
          width: 100,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "hist",
          headerName: t("common.historic"),
          width: 80,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => (
            <Tooltip title={t("common.viewHistoric")}>
              <span>
                <IconButton onClick={() => setHistoryId(params.row.id)}>
                  <HistoryToggleOffIcon />
                </IconButton>
              </span>
            </Tooltip>
          ),
        },
        {
          field: "idSku",
          headerName: t("common.skuCode"),
          type: "number",
          width: 150,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "siglaSku",
          headerName: t("common.acronym"),
          type: "string",
          width: 190,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "descricao",
          headerName: t("common.skuDescription.label"),
          type: "string",
          width: 300,
          editable: false,
          align: "left",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
        {
          field: "centro",
          headerName: t("common.center"),
          type: "number",
          width: 130,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "projeto",
          headerName: t("common.project"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "anoMesRef",
          headerName: t("common.monthYearRef"),
          type: "string",
          width: 150,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "dia",
          headerName: t("common.date"),
          type: "string",
          width: 150,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "quantidade",
          headerName: t("common.plannedQuantity"),
          type: "number",
          width: 170,
          editable: true,
          align: "right",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + " Kg",
          cellClassName: (gridItem: any) => {
            let forecastAtual = forecastsTemp.find(
              (forecast) => forecast.id == gridItem.id
            );
            if (forecastAtual) {
              return forecastAtual.quantidade + " Kg" != gridItem.formattedValue
                ? "celulaAlterada"
                : "";
            }
            return "";
          },
        },
        {
          field: "warning",
          headerName: "",
          width: 50,
          sortable: false,
          align: "center",
          filterable: false,
          renderCell: (params) => {
            const qtyPerMonth = maxQtyPerMonth?.[
              params.row.dia.substring(3)
            ] || { monthly: 0, used: 0 };
            const exceededMaxPerMonth = qtyPerMonth.used > qtyPerMonth.monthly;

            if (exceededMaxPerMonth) {
              return (
                <Tooltip
                  title={
                    <p>
                      {t("pages.dailyForecast.text.exceededMonthlyAmount")}{" "}
                      <br />
                      {t("pages.dailyForecast.text.monthlyTotalReported")}{" "}
                      {qtyPerMonth.used}kg <br />
                      {t("pages.dailyForecast.text.maxAvailable")}{" "}
                      {qtyPerMonth.monthly}kg <br />
                      {t("pages.dailyForecast.text.referenceMonthYear")}{" "}
                      {params.row.dia.substring(3)}
                    </p>
                  }
                >
                  <WarningIcon htmlColor={"rgba(0, 0, 0, 0.54)"} />
                </Tooltip>
              );
            }
            return <></>;
          },
        },
        // { field: 'saveico', headerName: '', width: 50, sortable: false, align: "center",
        //   renderCell: () => { return (
        //     <Tooltip title="Salvar">
        //       <span>
        //         <IconButton disabled={user.isSuporte}>
        //           <SaveIcon />
        //         </IconButton >
        //       </span></Tooltip>
        //   ); }
        // }
      ];
    }
    if (step === 2) {
      cols = [
        {
          field: "id",
          headerName: "#",
          width: 100,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "hist",
          headerName: t("common.historic"),
          width: 80,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => (
            <Tooltip title={t("common.viewHistoric")}>
              <span>
                <IconButton onClick={() => setHistoryId(params.row.id)}>
                  <HistoryToggleOffIcon />
                </IconButton>
              </span>
            </Tooltip>
          ),
        },
        {
          field: "idSku",
          headerName: t("common.skuCode"),
          type: "number",
          width: 150,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "siglaSku",
          headerName: t("common.acronym"),
          type: "string",
          width: 190,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "descricao",
          headerName: t("common.skuDescription.label"),
          type: "string",
          width: 300,
          editable: false,
          align: "left",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
        {
          field: "centro",
          headerName: t("common.center"),
          type: "number",
          width: 130,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "projeto",
          headerName: t("common.project"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "anoMesRef",
          headerName: t("common.monthYearRef"),
          type: "string",
          width: 150,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "dia",
          headerName: t("common.date"),
          type: "string",
          width: 150,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "quantidade",
          headerName: t("common.plannedQuantity"),
          type: "number",
          width: 170,
          editable: false,
          align: "right",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + " Kg",
        },
      ];
    }
    if (step > 2) {
      cols = [
        {
          field: "id",
          headerName: "#",
          width: 100,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "hist",
          headerName: t("common.historic"),
          width: 80,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => (
            <Tooltip title={t("common.viewHistoric")}>
              <span>
                <IconButton onClick={() => setHistoryId(params.row.id)}>
                  <HistoryToggleOffIcon />
                </IconButton>
              </span>
            </Tooltip>
          ),
        },
        {
          field: "idSku",
          headerName: t("common.skuCode"),
          type: "number",
          width: 150,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "siglaSku",
          headerName: t("common.acronym"),
          type: "string",
          width: 190,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "descricao",
          headerName: t("common.skuDescription.label"),
          type: "string",
          width: 300,
          editable: false,
          align: "left",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
        {
          field: "centro",
          headerName: t("common.center"),
          type: "number",
          width: 130,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "projeto",
          headerName: t("common.project"),
          type: "string",
          width: 110,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "anoMesRef",
          headerName: t("common.monthYearRef"),
          type: "string",
          width: 150,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "dia",
          headerName: t("common.date"),
          type: "string",
          width: 150,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "quantidade",
          headerName: t("common.quantity"),
          type: "number",
          width: 170,
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => round3(params.value) + " Kg",
        },
        // {
        //   field: "quantidadeProposta", headerName: "Quantidade Proposta", type: "number", width: 170, editable: false, align: "right", headerAlign: "center",
        //   valueFormatter: (params) => round3(params.value) + ' Kg'
        // },
        {
          field: "justificativa",
          headerName: t("common.justify"),
          width: 300,
          editable: false,
          align: "left",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
      ];
    }
    return cols;
  }

  function round3(value: number) {
    return value ? stripZeros(value.toFixed(3)) : 0;
  }

  function stripZeros(str: string) {
    return parseFloat(str.replace(",", ".")).toString().replace(".", ",");
  }

  function createData(
    id: number,
    codigoFornecedorSap: number,
    numeroContrato: string,
    idSku: string,
    descricao: string,
    centro: string,
    anoMesRef: string,
    dia: string,
    quantidade: number,
    quantidadeProposta: number,
    justificativa: string,
    quantidadeMensal = 0,
    projeto: string,
    siglaSku: string
  ): Data {
    return {
      id,
      codigoFornecedorSap,
      numeroContrato,
      idSku,
      descricao,
      centro,
      anoMesRef,
      dia,
      quantidade,
      quantidadeProposta,
      justificativa,
      quantidadeMensal,
      projeto,
      siglaSku,
    };
  }

  function preencherGrid(_data: ForecastDiarizado[]) {
    if (_data) {
      setRows(
        _data.map((item: ForecastDiarizado) => {
          return createData(
            Number(item.id),
            Number(item.codigoFornecedorSap),
            String(item.numeroContrato),
            String(item.idSku),
            String(item.skuDescricao),
            String(item.centro),
            String(
              item.anoMesRef.toString().substring(6, 4) +
                "/" +
                item.anoMesRef.toString().substring(0, 4)
            ),
            String(
              item.dia.toString().substring(10, 8) +
                "/" +
                item.dia.toString().substring(7, 5) +
                "/" +
                item.dia.toString().substring(0, 4)
            ),
            Number(item.quantidade),
            Number(item.quantidadeProposta),
            String(item.justificativa),
            item.quantidadeMensal,
            item.projeto,
            item.siglaSku
          );
        })
      );
    }
  }

  const Mensagem = (
    titulo: string,
    mensagem: string,
    wait: boolean = false,
    time: number = 0,
    refresh: boolean = true
  ) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        !wait
          ? {
              label: t("common.ok"),
              onClick: () => {
                setOpen(false);
                if (refresh) {
                  PageHelper.refreshPage();
                }
              },
            }
          : {
              label: t("common.ok"),
              onClick: () => {
                setTimeout(function () {
                  setOpen(false);
                }, time);
              },
            },
      ],
    });
  };

  function MensagemBackgoundProcess(records: number) {
    <CircularProgress />;
  }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
    setOpenPlanoMovidoSnackBar(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  function handleCloseModalMoverPlano() {
    setOpenModalMoverPlano({ isOpen: false, idForecastAtual: -1 });
  }

  const handleClickOpenDownloadCSV = () => {
    setOpenDownloadCSVModal(true);
  };

  function handleCloseDownloadCSVModal() {
    setOpenDownloadCSVModal(false);
  }

  function handleClickOpenCSVDetalhesModal() {
    setOpenCSVDetalhesModal(true);
  }

  function handleCloseCSVDetalhesModal() {
    setOpenCSVDetalhesModal(false);
  }

  const [openFilter, setOpenFilter] = React.useState(false);

  const handleClickOpenFilter = () => {
    setFilter({} as IFilter);
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  function handleSelectionChange(ids: any) {
    if (ids !== null && ids !== undefined && ids.length > 0) {
      localStorage.setItem("idsForecastDiario", ids);
      setHabilita(true);
    } else {
      localStorage.removeItem("idsForecastDiario");
      setHabilita(false);
    }
  }

  function FileUploadPage() {
    if (codigoFornecedorSap && contrato?.numeroContrato && step) {
      return (
        <div>
          <FileUpload
            {...{
              endpoint:
                "Forecast/Diarizado/ProcessarPlanilha/Parceiro/" +
                codigoFornecedorSap +
                "/Contrato/" +
                contrato.numeroContrato +
                "/Passo/" +
                step,
              setCsvFoiEnviado: setCsvFoiEnviado,
            }}
          />
        </div>
      );
    } else {
      return <></>;
    }
  }

  const handleCellEdtStart = (params: any) => {
    SetValorAnterior(
      step === 1 ? params.row.quantidade : params.row.quantidadeProposta
    );
    // console.log(JSON.stringify(params));
  };

  const handleRowEditCommit = (params: any) => {
    // console.log(JSON.stringify(params));
    if (
      params.field === "quantidade" ||
      params.field === "quantidadeProposta" ||
      params.field === "justificativa"
    ) {
      const index = forecasts.findIndex((f) => f.id === params.id);
      if (
        (params.field === "quantidade" ||
          params.field === "quantidadeProposta") &&
        Number(params.value) < 0
      ) {
        alert(t("pages.dailyForecast.text.negativeValues"));
        const updatedForecast =
          params.field === "quantidade"
            ? { ...forecasts[index], quantidade: valorAnterior }
            : params.field === "quantidadeProposta"
            ? { ...forecasts[index], quantidadeProposta: valorAnterior }
            : undefined;
        if (updatedForecast !== undefined) {
          const tempRows = [
            ...forecasts.slice(0, index),
            updatedForecast,
            ...forecasts.slice(index + 1),
          ];
          setForecasts(tempRows);
          preencherGrid(tempRows);
        }
      } else {
        const row = forecasts[index] as any;
        if (params.field in row && row[params.field] !== params.value) {
          const tempRows = [...forecasts] as any;
          tempRows[index][params.field] = params.value;
          setForecasts(tempRows);
          preencherGrid(tempRows);
        }
      }
    }
    // AVISO TODO TO-DO TODO WARNING:
    // Isso tá quebrando a tabela na atualização manual de colunas,
    // Fazendo-a carregar TODOS os Forecasts Diários de uma só vez,
    // sem manter o filtro de step.

    // Para causar esse erro, atualize o campo "quantidade" manualmente pela tabela e analise os resultados da variável filtered.

    // Por essa razão, comentei essa chamada de função. Descomente quando for debuggar.
    // handleFilter()
  };

  const handleClickFilter = () => {
    if (filtra) {
      // Limpa modal de filtro
      window.location.reload();
    } else {
      handleClickOpenFilter();
    }
    setFiltra(!filtra);
  };

  const handleFilter = async () => {
    const requestData = {
      numeroContrato: String(contrato.numeroContrato),
      ...filter,
      [FILTER_NAMES.mesAnoReferencia]:
        filter[FILTER_NAMES.mesAnoReferencia]
          ?.toLocaleDateString("pt-BR")
          .substring(3)
          .split("/")
          .reverse()
          .join("") || "",
      [FILTER_NAMES.valueDTinicio]: filter[FILTER_NAMES.valueDTinicio]
        ? moment(filter[FILTER_NAMES.valueDTinicio]).format("YYYY-MM-DD")
        : null,
      [FILTER_NAMES.valueDTfim]: filter[FILTER_NAMES.valueDTfim]
        ? moment(filter[FILTER_NAMES.valueDTfim]).format("YYYY-MM-DD")
        : null,
      [FILTER_NAMES.codigoSku]:
        (filter[FILTER_NAMES.codigoSku] || []).length > 0
          ? filter[FILTER_NAMES.codigoSku]
              ?.map((item) => item.split(" - ")[0])
              .join(",")
          : null,
    };

    const filtered: ForecastDiarizado[] =
      await dataForecastDiarizado.RecuperarPorFiltros(
        requestData,
        codigoFornecedorSap,
        _step
      );

    if (filtered.length > 0) {
      preencherGrid(filtered);
    } else {
      preencherGrid([]);
    }

    setOpenFilter(false);
  };

  const getDownloadColumns = () => {
    return columns.filter(
      (x) =>
        x.field != "siglaSku" &&
        x.field != "moverPlanoIco" &&
        x.field != "hist" &&
        x.field != "warning"
    );
  };

  const getDownloadRows = () => {
    return rows.map((row) => {
      return {
        ...row,
        quantidade: (row.quantidade + "").replace(".", ","),
        quantidadeProposta: (row.quantidadeProposta + "").replace(".", ","),
        quantidadeMensal: (row.quantidadeMensal + "").replace(".", ","),
      };
    });
  };

  return (
    <div className={`container ${styles.container}`}>
      <ForecastTopo />
      <div className="containerToolbar">
        {filtra === false ? (
          <Tooltip title={t("pages.dailyForecast.text.enablesFilteringGrid")}>
            <span>
              <IconButton
                onClick={handleClickFilter}
                disabled={!(rows.length >= 0) || loading}
              >
                <FilterAltIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip
            title={t("pages.dailyForecast.text.disableFiltersAndReturn")}
          >
            <span>
              <IconButton
                onClick={handleClickFilter}
                disabled={!filtra || loading}
              >
                <FilterAltOffIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
        {step === 1 || step === 2 ? (
          <Tooltip title={t("pages.dailyForecast.text.viewRatioData")}>
            <span>
              <IconButton onClick={handleClickDadosForecast} disabled={loading}>
                <AssessmentIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {step < 2 ? (
          <Tooltip
            title={t("pages.dailyForecast.text.saveChangesToSelectedItem")}
          >
            <span>
              <IconButton
                onClick={handleClickSave}
                disabled={loading || user.isSuporte}
              >
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {step < 2 ? (
          <Tooltip title={t("pages.dailyForecast.text.uploadCsvFile")}>
            <span>
              <IconButton
                onClick={handleClickOpen}
                disabled={loading || user.isSuporte}
              >
                <FileUploadIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {step <= 3 ? (
          // <CSVLink filename="forecastDiario.csv" data={forecasts.map((item) => {
          //   return createDownload(
          //     item.idSku, item.centro, String(item.dia.toString().substring(10, 8) + "/" + item.dia.toString().substring(7, 5) + "/" + item.dia.toString().substring(0, 4)),
          //     stripZeros(String(item.quantidade)), item.justificativa);
          // })}
          //   // onClick={() => { console.log("You click the link"); }}
          //   enclosingCharacter={``}
          //   separator={";"}>
          <Tooltip title={t("pages.dailyForecast.text.downloadCsvFile")}>
            <span>
              <IconButton
                onClick={handleClickOpenDownloadCSV}
                disabled={loading || user.isSuporte}
              >
                <Download />
              </IconButton>
            </span>
          </Tooltip>
        ) : // </CSVLink>
        null}{" "}
        {(step < 3 && (user.isPlanejamentoBRF || user.isRoot)) || step == 1 ? (
          <Tooltip title={titleAprova}>
            <span>
              <IconButton
                onClick={() =>
                  handleConfimation(
                    t("common.warning"),
                    t("pages.dailyForecast.text.doYouWantContinue")
                  )
                }
                disabled={loading || user.isSuporte}
              >
                <Send />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
        {step === 2 && (user.isPlanejamentoBRF || user.isRoot) ? (
          <Tooltip title={t("pages.dailyForecast.text.reproveAllItems")}>
            <span>
              <IconButton
                onClick={handleClickNotAprove}
                disabled={loading || user.isSuporte}
              >
                <NotInterestedIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}{" "}
      </div>
      <div className={`divFlow ${styles.table}`}>
        <div className={styles.table}>
          <DataGrid
            loading={loading}
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[50, 100, 250, 500]}
            // onSelectionModelChange={(ids) => { handleSelectionChange(ids) }}
            onCellEditCommit={handleRowEditCommit}
            onCellEditStart={handleCellEdtStart}
            onCellClick={(cellValues) => handleClick(cellValues)}
            // checkboxSelection={step <= 3}
            disableSelectionOnClick
          />
        </div>
      </div>
      {user.isRoot && (
        <div className="divFlow">
          <ForecastDiarizadoPassoAPasso {...{ data: step }} />
        </div>
      )}
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t("pages.dailyForecast.text.excelImport")}
            <br />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <br />
              {FileUploadPage()}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              color="success"
              onClick={handleClose}
              autoFocus
            >
              {t("common.close")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        <Dialog
          open={openFilter}
          onClose={handleCloseFilter}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="filter"
        >
          <DialogTitle id="alert-dialog-title">
            {t("common.filter")}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12}>
                {/* <TextField
                  value={codigoSku}
                  id={"CodSku"}
                  name={"CodSku"}
                  label="Código Sku"
                  placeholder="Código Sku"
                  variant="outlined"
                  fullWidth
                  onChange={event => setCodigoSku(event.target.value)}
                /> */}
                <AutocompleteSKU
                  multiple
                  onChangeCallback={(e, newValue) => {
                    handleChangeFilter({
                      target: { name: FILTER_NAMES.codigoSku, value: newValue },
                    });
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={"DesSku"}
                  value={filter[FILTER_NAMES.descricaoSku]}
                  name={FILTER_NAMES.descricaoSku}
                  label={t("common.skuDescription.label.label")}
                  placeholder={t("common.skuDescription.label.placeholder")}
                  variant="outlined"
                  fullWidth
                  onChange={handleChangeFilter}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={filter[FILTER_NAMES.centroDistribuicao]}
                  id={"Centro"}
                  name={FILTER_NAMES.centroDistribuicao}
                  label={t("common.distributionCenter.label")}
                  placeholder={t("common.distributionCenter.placeholder")}
                  variant="outlined"
                  fullWidth
                  onChange={handleChangeFilter}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={filter[FILTER_NAMES.quantidade]}
                  id={"Quantidade"}
                  name={FILTER_NAMES.quantidade}
                  label={t("common.quantity.label")}
                  placeholder="Quantidade"
                  variant="outlined"
                  fullWidth
                  onChange={handleChangeFilter}
                />
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  locale={ptBR}
                >
                  <DatePicker
                    label={
                      <div className={styles["datepicker-label"]}>
                        Mês e ano referência
                      </div>
                    }
                    value={filter[FILTER_NAMES.mesAnoReferencia]}
                    views={["month", "year"]}
                    onChange={(newValue: any) => {
                      handleChangeFilter({
                        target: {
                          name: FILTER_NAMES.mesAnoReferencia,
                          value: newValue,
                        },
                      });
                    }}
                    inputFormat="MM/yyyy"
                    renderInput={(params: any) => (
                      <TextField
                        {...params}
                        {...(!!filter[FILTER_NAMES.mesAnoReferencia] && {
                          value: filter[FILTER_NAMES.mesAnoReferencia]
                            ?.toLocaleDateString("pt-BR")
                            .substring(3),
                          InputLabelProps: { shrink: true },
                        })}
                        size="small"
                        onChange={(event) => {
                          const { value } = event.target;
                          if (value.length === 7) {
                            try {
                              handleChangeFilter({
                                target: {
                                  name: FILTER_NAMES.mesAnoReferencia,
                                  value: new Date(
                                    Number(value.split("/")[1]),
                                    Number(value.split("/")[0]) - 1
                                  ),
                                },
                              });
                            } catch (err) {
                              console.log("wrong value to date: ", value);
                            }
                          } else {
                            handleChangeFilter({
                              target: {
                                name: FILTER_NAMES.mesAnoReferencia,
                                value: null,
                              },
                            });
                          }
                        }}
                        inputProps={{
                          placeholder: "04/2022",
                          className: styles["datepicker-height"],
                        }}
                      />
                    )}
                    className={styles["datepicker-full"]}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  locale={ptBR}
                >
                  <DatePicker
                    inputFormat="dd/MM/yyyy"
                    label={t("common.initialDate")}
                    value={filter[FILTER_NAMES.valueDTinicio]}
                    onChange={(newValue) => {
                      if (newValue) {
                        newValue.setHours(0);
                        newValue.setMinutes(0);
                        newValue.setSeconds(0);
                        newValue.setMilliseconds(0);
                      }
                      handleChangeFilter({
                        target: {
                          name: FILTER_NAMES.valueDTinicio,
                          value: newValue,
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        {...(!!filter[FILTER_NAMES.valueDTinicio] && {
                          value:
                            filter[
                              FILTER_NAMES.valueDTinicio
                            ]?.toLocaleDateString("pt-BR"),
                          InputLabelProps: { shrink: true },
                        })}
                        inputProps={{ placeholder: "01/04/2022" }}
                      />
                    )}
                    className={styles["datepicker-full"]}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  locale={ptBR}
                >
                  <DatePicker
                    inputFormat="dd/MM/yyyy"
                    label={t("common.finalDate")}
                    value={filter[FILTER_NAMES.valueDTfim]}
                    onChange={(newValue) => {
                      if (newValue) {
                        newValue.setHours(23);
                        newValue.setMinutes(59);
                        newValue.setSeconds(59);
                        newValue.setMilliseconds(999);
                      }
                      handleChangeFilter({
                        target: {
                          name: FILTER_NAMES.valueDTfim,
                          value: newValue,
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        {...(!!filter[FILTER_NAMES.valueDTfim] && {
                          value:
                            filter[FILTER_NAMES.valueDTfim]?.toLocaleDateString(
                              "pt-BR"
                            ),
                          InputLabelProps: { shrink: true },
                        })}
                        inputProps={{ placeholder: "01/04/2022" }}
                      />
                    )}
                    className={styles["datepicker-full"]}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid justifyContent="space-between" container padding={2}>
              <Grid item>
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={handleCloseFilter}
                  autoFocus
                  className={"button-close-dialog"}
                >
                  {t("common.close")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleFilter}
                  autoFocus
                >
                  {t("common.filter")}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <ForecastDiarioModal
          handleClose={handleCloseModal}
          forecastsDiarizados={forecasts}
        />
      </Modal>
      <Modal
        open={openModalMoverPlano.isOpen}
        onClose={handleCloseModalMoverPlano}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <ForecastDiarioMoverPlanoModal
          handleClose={handleCloseModalMoverPlano}
          forecastsDiarizados={forecasts}
          idForecastAtual={openModalMoverPlano.idForecastAtual}
          setPlanoFoiMovido={setPlanoFoiMovido}
        />
      </Modal>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity={csvFoiEnviado.isSuccess ? "success" : "error"}
          sx={{ width: "100%" }}
          action={
            <Button
              color="primary"
              size="small"
              onClick={handleClickOpenCSVDetalhesModal}
            >
              {t("common.seeDetails")}
            </Button>
          }
        >
          {csvFoiEnviado.isSuccess
            ? t("pages.dailyForecast.text.csvWithSuccess")
            : t("pages.dailyForecast.text.csvWithFail")}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openPlanoMovidoSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity={planoFoiMovido.isSuccess ? "success" : "error"}
          sx={{ width: "100%" }}
        >
          {planoFoiMovido.isSuccess
            ? t("pages.dailyForecast.text.movePlanWithSuccess")
            : t("pages.dailyForecast.text.movePlanWithFail")}
        </Alert>
      </Snackbar>
      <Modal
        open={openDownloadCSVModal}
        onClose={handleCloseDownloadCSVModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <DownloadCSVModal
          handleClose={handleCloseDownloadCSVModal}
          rows={getDownloadRows()}
          columns={getDownloadColumns()}
          name={`${t("pages.dailyForecast.text.dailyForecastStep")} ${step}`}
        />
      </Modal>

      <Modal
        open={openCSVDetalhesModal}
        onClose={handleCloseCSVDetalhesModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <CSVDetalhesModal
          handleClose={handleCloseCSVDetalhesModal}
          name={`${t("pages.dailyForecast.text.dailyForecastStep")} ${step}`}
          detalhes={csvFoiEnviado.details}
        />
      </Modal>

      {historyId > 0 && (
        <StepLogsHistoryDetalhe
          id={historyId}
          type={"ForecastDiario"}
          onClose={() => setHistoryId(0)}
        />
      )}
    </div>
  );
}
/*
error={valueDTfim !== null && valueDTinicio !== null && valueDTfim < valueDTinicio ? false : true}
error={valueDTfim !== null && valueDTinicio !== null && valueDTfim < valueDTinicio ? false : true}

 */
